import type { StepView } from "@/app/queries";
import { CheckRow } from "@/ui/CheckRow";
import { practiceThreshold, tasksDone, type Task, type TickFn } from "./model";

/** Практика (S4): базовый / применение — в гейте, счётчики из оценки гейта;
 *  третья карточка «Дополнительно · вне гейта» отмечается видом extra. */
export function Practice({ view, tick }: { view: StepView; tick: TickFn }) {
  const g = view.gate;
  const { base, apply, extra } = view.content.practice;
  return (
    <section id="practice" className="scroll-mt-20">
      <div className="mb-3 flex items-baseline gap-2.5">
        <h2 className="m-0 font-mono text-[15px] font-semibold">Практика</h2>
        <span className="font-mono text-[11.5px] text-mut" data-testid="tasks-summary">
          {g.tasks_done} / {g.tasks_total} задач отмечено · для гейта нужно {practiceThreshold(view)}%
        </span>
      </div>
      <div className="flex flex-col gap-4">
        <LevelCard title="Базовый" level="base" tasks={base} ticked={view.ticks.tasks} tick={tick} />
        <LevelCard title="Применение" level="apply" tasks={apply} ticked={view.ticks.tasks} tick={tick} />
        <LevelCard title="Дополнительно · вне гейта" level="extra" tasks={extra} ticked={view.ticks.extra} tick={tick} note="для тех, кто хочет глубже — гейт эти задачи не считает" />
      </div>
    </section>
  );
}

export function LevelCard({
  title,
  level,
  tasks,
  ticked,
  tick,
  note,
}: {
  title: string;
  level: "base" | "apply" | "extra";
  tasks: Task[];
  ticked: string[];
  tick: TickFn;
  note?: string;
}) {
  if (tasks.length === 0) return null;
  const set = new Set(ticked);
  const done = tasksDone(tasks, set);
  const kind = level === "extra" ? "extra" : "task";
  return (
    <div className={`overflow-hidden rounded-md border bg-card ${level === "extra" ? "border-dashed border-bd2" : "border-bd"}`} data-testid="practice-level" data-level={level}>
      <div className="flex items-center gap-2.5 border-b border-bd px-3.5 py-[11px]">
        <span className="text-[13.5px] font-semibold">{title}</span>
        <span className="flex-1" />
        <span className={`font-mono text-[11px] ${done === tasks.length ? "text-ok" : "text-mut"}`}>
          {done} / {tasks.length}
        </span>
      </div>
      {note && <div className="border-b border-bd px-3.5 py-2 font-mono text-[11px] text-mut">{note}</div>}
      {tasks.map((t) => (
        <div key={t.id} id={`${kind}-${t.id}`} className="border-b border-bd px-3.5 last:border-b-0">
          <CheckRow checked={set.has(t.id)} onChange={(on) => tick({ kind, key: t.id, on })} label={<span className="text-pretty">{t.text}</span>} />
        </div>
      ))}
    </div>
  );
}
